import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import Scroller from "../../Scroller/Scroller";
import Submenu from "./Submenu";

gsap.registerPlugin(ScrollTrigger);

const Anchor = {
        init(el) {
            this.anchors = $('a[href*="#"]');
            if (!this.anchors.length) return;

            this.bind();
        },

        bind() {
            this.anchors.click((evt) => {
                evt.stopPropagation();
                // evt.preventDefault();

                const el = $(evt.currentTarget);
                const id = el.attr('href').split('#')[1];
                const hash = '#' + id;
                const handler = el.attr('handler');

                this.setUrlHistory(el, hash);
                Submenu.select(id);

                if(handler && handler.length){
                    this.setByAnchor(el, handler);
                    return false;
                }

                const isInScroll = $(hash).length > 0;
                console.log(isInScroll)
                if (!isInScroll) return true;



                this.scroll(hash);
                return true;

            });

        },

        setByAnchor(el, handler) {
            window[handler]
            && typeof window[handler].setByAnchor === 'function'
            && window[handler].setByAnchor(el);
        },

        scroll(hash) {
            gsap.to(window, {
                scrollTo: {y: hash, offsetY: 86}, ease: "none",
                duration: Scroller.animTime,
                onComplete: function () {
                    // window.location.hash = hash;
                }
            });
        },

        setUrlHistory(el, hash) {
            const title = el.attr('title');
            window.history.pushState({}, title, hash);
        }
}

export default Anchor